// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workerInfoMain {
    font-size: 14px;
    line-height: initial;
}

.workerInfoSub {
    font-size: 10px;
    line-height: initial;
}

.content {
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 14px;
    color: black;
    line-height: initial;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/worker/worker.info.control.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,oBAAoB;AACxB","sourcesContent":[".workerInfoMain {\n    font-size: 14px;\n    line-height: initial;\n}\n\n.workerInfoSub {\n    font-size: 10px;\n    line-height: initial;\n}\n\n.content {\n    white-space: pre-wrap;\n    word-break: break-word;\n    font-size: 14px;\n    color: black;\n    line-height: initial;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
